const STORAGE_KEY_PREFIX = 'chainsight_graph_context:';

export const graphContextCacheKey = (userId) => `${STORAGE_KEY_PREFIX}${userId}`;

export const getGraphContextCache = (userId) => {
  if (!userId || typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(graphContextCacheKey(userId));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const setGraphContextCache = (userId, payload) => {
  if (!userId || typeof sessionStorage === 'undefined' || !payload) return;
  try {
    sessionStorage.setItem(
      graphContextCacheKey(userId),
      JSON.stringify({
        nodesByKey: payload.nodesByKey ?? {},
        companyRoutes: payload.companyRoutes ?? {},
        etag: payload.etag ?? '',
        cachedAt: Date.now(),
      })
    );
  } catch {
    // ignore quota errors
  }
};

export const clearGraphContextCache = (userId) => {
  if (!userId || typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(graphContextCacheKey(userId));
  } catch {
    // ignore
  }
};
